import Button from "../../../independent/Button";
import React from "react";

const AddHistoryFooter = ({subModalMount, closeModal, closeSubModal, showCustomerCodeInput}) => {


  return (
    <div className={"add-design-history-footer"}>
      <div className={"detail-design-history-inner"}>
        <span>* Please do not share sensitive information.</span>
        <div className={"detail-design-history-footer-buttons"}>
          <Button name={"SAVE"}
                  onClick={() => showCustomerCodeInput(subModalMount, closeModal, closeSubModal)}
                  block={false}
          />
        </div>
      </div>
    </div>
  )
}

export default AddHistoryFooter;
